export function normalizeWhatsAppId(val) {
  let s = String(val || '').trim()
  if (!s) return ''
  s = s.replace(/@.*$/, '')
  s = s.replace(/[\s-]/g, '')
  s = s.replace(/^\+/, '')
  s = s.replace(/\D/g, '')
  return s
}
